import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { UserService } from './user.service';
import { User } from '../objects/user';

/**
 * Keeps Sentry scope in sync with the logged-in application user
 * (email, display name, and non-PII context for triage).
 */
@Injectable({
  providedIn: 'root',
})
export class SentryUserContextService {
  constructor(private userService: UserService) {
    this.userService.user.subscribe((user: User) => this.sync(user));
  }

  private sync(user: User): void {
    const email = user?.email?.trim();
    if (!email) {
      Sentry.setUser(null);
      Sentry.setContext('user_profile', null);
      return;
    }

    const displayName = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();

    Sentry.setUser({
      id: email,
      email,
      username: displayName || email,
    });

    Sentry.setContext('user_profile', {
      role: user.role,
      country: user.country,
      companyName: user.companyName,
      isPremium: user.isPremium,
      hasIntegration: user.hasIntegration,
    });
  }
}
